import 'exenv';
const isWebView = () => typeof MobileWebKit !== 'undefined';
const isWebkit2 = () => {
  var _MobileWebKit, _MobileWebKit2;
  return isWebView() && typeof ((_MobileWebKit = MobileWebKit) === null || _MobileWebKit === void 0 ? void 0 : _MobileWebKit.executeNative) === 'function' && typeof MobileWebKit.events !== 'undefined' && typeof MobileWebKit.events.subscribeMethod === 'function' && typeof MobileWebKit.events.unsubscribe === 'function' && MobileWebKit.engine === ((_MobileWebKit2 = MobileWebKit) === null || _MobileWebKit2 === void 0 || (_MobileWebKit2 = _MobileWebKit2.Engines) === null || _MobileWebKit2 === void 0 ? void 0 : _MobileWebKit2.V200);
};
const open = input => {
  var _MobileWebKit;
  if (!isWebkit2()) {
    return;
  }
  const {
    inputMode,
    type,
    id
  } = input;
  let inputType = inputMode || type;
  if (type === 'tel') {
    inputType = 'phone';
  }
  if (inputMode === 'decimal') {
    inputType = 'numberDecimal';
  }
  if (typeof ((_MobileWebKit = MobileWebKit) === null || _MobileWebKit === void 0 ? void 0 : _MobileWebKit.actions.openKeyboard) === 'function') {
    MobileWebKit.actions.openKeyboard(id, inputType).catch(() => {});
  }
};
const hasTouchSupport = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;
const autofocus = function (input) {
  let firstRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (firstRender) {
    open(input);
  }
  if (!isWebView() && !hasTouchSupport() && typeof input.focus === 'function') {
    input.focus();
  }
};
export { autofocus };
